import React from 'react';
import { Plus } from 'lucide-react';
import { TabsList, TabsTrigger } from '../../ui/tabs';
import { Button } from '../../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu';

type Props = {
  showTeacherTab: boolean;
  canAddTeacherRole?: boolean;
  onAddTeacherRole?: () => void;
};

export default function PersonDetailTabs({
  showTeacherTab,
  canAddTeacherRole = false,
  onAddTeacherRole,
}: Readonly<Props>) {
  return (
    <TabsList>
      <TabsTrigger value="general">Allgemein</TabsTrigger>
      <TabsTrigger value="customer">Kunde</TabsTrigger>
      {showTeacherTab && <TabsTrigger value="teacher">Lehrer</TabsTrigger>}
      {canAddTeacherRole && onAddTeacherRole ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-9 rounded-sm px-3 text-sm font-medium"
              aria-label="Rolle hinzufügen"
            >
              <Plus className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuItem onClick={onAddTeacherRole}>Lehrer</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ) : null}
    </TabsList>
  );
}
